import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { FormikProps, useFormik, FormikErrors } from 'formik';
import { Filter } from '~/component/common/Filter';
import * as api from '~/myApi'
import * as enums from '~/const/enums'

import FormField from '~/component/form/FormField'
import TextField from '~/component/form/TextField'
import Select from '~/component/form/Select'

export interface FormFilterProps<T> {
  initialValues: T,
}

export const SurveyFilterForm: React.FC<{
  values: FormType,
  errors?: FormikErrors<FormType>
}> = (props) => {
  return (
    <>
      <FormField label="ID" errorMessage={props.errors?.id}>
        <TextField {...{
          name: 'id',
          type: 'number', 
          value: props.values?.id,
          error: !!props.errors?.id
        }} />
      </FormField>

      <FormField label="サーベイ名" errorMessage={props.errors?.name}>
        <TextField {...{
          name: 'name',
          type: 'string', 
          value: props.values?.name,
          error: !!props.errors?.name
        }} />
      </FormField>

      <FormField label="配信">
        <Select {...{
          name: 'status',
          value: props.values?.status,
          items: enums.SURVEY_STATUS,
          width: 200
        }} />
      </FormField>
    </>
  );
};

type FormType = Pick<
  api.ServerFindSurveyFilter & api.ServerPagination,
  'name' | 'status' | 'page'
> & { id?: string };
export const SurveyFilter: React.FC<FormFilterProps<FormType>> = ({
  initialValues,
}) => {

  const init = _.merge({}, {
    name: '',
    status: ''
  }, initialValues)

  const formik: FormikProps<FormType> = useFormik<FormType>({
    initialValues: init,
    onSubmit: () => Promise.resolve(),
    validateOnBlur: true,
    validateOnChange: false,
    enableReinitialize: true,
  });

  return (
    <Filter {...{ 
      formik,
      page: initialValues.page
    }}>
      <SurveyFilterForm 
        values={formik.values}
      />
    </Filter>
  );
};
